import {useQuery} from 'react-query'
import {getCategories, getHowMetOptions, getMetricOptions} from './_requests'

const staticQuery = {staleTime: Infinity, refetchOnWindowFocus: false}

// Opções dos filtros e rótulos do relatório (códigos de produto, status, faixas, sexo, origem e categorias).
const useMetricOptions = () => {
  const {data: options} = useQuery('metric-options', getMetricOptions, staticQuery)
  const {data: howMetOptions} = useQuery('metric-how-met-options', getHowMetOptions, staticQuery)
  const {data: categories} = useQuery('metric-categories', getCategories, staticQuery)

  return {
    products: options?.products ?? [],
    statuses: options?.statuses ?? [],
    genders: options?.genders ?? [],
    purchaseRanges: options?.purchaseRanges ?? [],
    lastPurchaseRanges: options?.lastPurchaseRanges ?? [],
    howMetOptions: howMetOptions ?? [],
    categories: categories ?? [],
  }
}

export {useMetricOptions}
